import { printIonWarning } from './logging';
import {
    addEventListener,
    removeEventListener,
  } from './helpers';

export interface HTMLStencilElement extends HTMLElement {
    componentOnReady(): Promise<this>;
}

export interface HTMLIonOverlayElement extends HTMLStencilElement {
    overlayIndex: number;
    // backdropDismiss?: boolean;
    // lastFocus?: HTMLElement;

    // dismiss(data?: any, role?: string): Promise<boolean>;
    // present: () => Promise<void>;
}

export const onceEvent = (element: HTMLElement, eventName: string, callback: (ev: Event) => void) => {
    const handler = (ev: Event) => {
        removeEventListener(element, eventName, handler);
        callback(ev);
    };
    addEventListener(element, eventName, handler);
};

export const eventMethod = <T>(element: HTMLElement, eventName: string): Promise<T> => {
    let resolve: (detail: T) => void;
    const promise = new Promise<T>((r) => (resolve = r));
    onceEvent(element, eventName, (event: any) => {
        resolve(event.detail);
    });
    return promise;
};

/**
 * 创建一个触发器覆盖交互
 * 触发器被点击时触发
 * 使用:
 *  triggerController = createTriggerController();
 *  triggerController.addClickListener(el, trigger);
 * ```
 */
export const createTriggerController = () => {
    let destroyTriggerInteraction: (() => void) | undefined;
    let destroyCloseTriggerInteraction: (() => void) | undefined;

    /**
     * 从触发器元素中删除click侦听器。
     */
    const removeClickListener = (): void => {
        if (destroyTriggerInteraction) {
            destroyTriggerInteraction();
            destroyTriggerInteraction = undefined;
        }
    };

    const removeCloseClickListener = ():void => {
        if (destroyCloseTriggerInteraction) {
            destroyCloseTriggerInteraction();
            destroyCloseTriggerInteraction = undefined;
        }
    }

    /**
     * 向触发器元素添加单击侦听器。
     * Presents the overlay when the trigger is clicked.
     * @param el The overlay element.
     * @param trigger The ID of the element to add a click listener to.
     */
    const addClickListener = (el: HTMLJackeryModalElement, trigger: string): void => {
        removeClickListener();

        const triggerEl = trigger !== undefined ? document.getElementById(trigger) : null;
        if (!triggerEl) {
            printIonWarning(
                `A trigger element with the ID "${trigger}" was not found in the DOM. The trigger element must be in the DOM when the "trigger" property is set on an overlay component.`,
                el
            );
            return;
        }

        const configureTriggerInteraction = (targetEl: HTMLElement, overlayEl: HTMLJackeryModalElement) => {
            const openOverlay = () => {
                overlayEl.show()
                console.log(overlayEl)
            };
            targetEl.addEventListener('click', openOverlay);

            return () => {
                targetEl.removeEventListener('click', openOverlay);
            };
        };

        destroyTriggerInteraction = configureTriggerInteraction(triggerEl, el);
    };

    /**
     * 向触发器元素添加单击侦听器-关闭。
     * Presents the overlay when the trigger is clicked.
     * @param el The overlay element.
     * @param trigger The ID of the element to add a click listener to.
     */
     const addClickCloseListener = (el: HTMLJackeryModalElement, trigger: string): void => {
        removeCloseClickListener();

        const triggerEl = trigger !== undefined ? document.getElementById(trigger) : null;
        if (!triggerEl) {
            printIonWarning(
                `A trigger element with the ID "${trigger}" was not found in the DOM. The trigger element must be in the DOM when the "trigger" property is set on an overlay component.`,
                el
            );
            return;
        }

        const configureTriggerInteraction = (targetEl: HTMLElement, overlayEl: HTMLJackeryModalElement) => {
            const hideOverlay = () => {
                overlayEl.hide()
                console.log(overlayEl)
            };
            targetEl.addEventListener('click', hideOverlay);

            return () => {
                targetEl.removeEventListener('click', hideOverlay);
            };
        };

        destroyCloseTriggerInteraction = configureTriggerInteraction(triggerEl, el);
    };

    return {
        addClickListener,
        removeClickListener,
        removeCloseClickListener,
        addClickCloseListener
    };
};
  